const { valueOrNull, boolValue } = require('./components/utils');

/** utm_campaign for every link to the Bidali app download page. */
const appDownloadCampaign = 'giftcards_customer_remarketing';

module.exports = {
  rootUrl: process.env.NEXT_PUBLIC_ROOT_URL,
  assetsUrl: 'https://assets.bidali.com',
  paymentsApiUrl: process.env.NEXT_PUBLIC_PAYMENTS_API_URL,
  paymentsApiPublishableKey: process.env.NEXT_PUBLIC_PAYMENTS_API_PUBLISHABLE_KEY,
  blockchainApiUrl: process.env.NEXT_PUBLIC_BLOCKCHAIN_API_URL,
  commerceApiUrl: process.env.NEXT_PUBLIC_COMMERCE_API_URL,
  commerceWebUrl: process.env.NEXT_PUBLIC_COMMERCE_WEB_URL,
  commerceEnv: process.env.NEXT_PUBLIC_COMMERCE_ENV,
  commerceReferrerApiKey: process.env.NEXT_PUBLIC_COMMERCE_REFERRER_API_KEY,
  gaTrackingId: valueOrNull(process.env.NEXT_PUBLIC_GA_TRACKING_ID),
  adwordsConversionId: valueOrNull(process.env.NEXT_PUBLIC_ADWORDS_CONVERSION_ID),
  adwordsConversionLabel: valueOrNull(process.env.NEXT_PUBLIC_ADWORDS_CONVERSION_LABEL),
  facebookPixelId: valueOrNull(process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID),
  facebookPixelLoggingEnabled: boolValue(process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_LOGGING_ENABLED),
  redditAdvertiserId: valueOrNull(process.env.NEXT_PUBLIC_REDDIT_ADVERTISER_ID),
  helpScoutBeaconId: valueOrNull(process.env.NEXT_PUBLIC_HELPSCOUT_BEACON_ID),
  bugsnagApiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
  securityNoticeUrl: valueOrNull(process.env.NEXT_PUBLIC_SECURITY_NOTICE_URL),
  inMaintenanceMode: boolValue(process.env.NEXT_PUBLIC_IN_MAINTENANCE_MODE),
  debugLogging: boolValue(process.env.NEXT_PUBLIC_DEBUG_LOGGING),
  appDownloadCampaign,
  supportUrl: 'https://support.bidali.com',
  supportEmail: 'support.spend@bidali.com',
  addYourBusinessUrl:
    'https://webforms.pipedrive.com/f/2XDkDOjqONUu7rx7Qk5I54WHpBDOy5cvlydcajemhzrBLh1GNpu5rvXC2IQr05pvl',
  brandRequestUrl:
    'https://docs.google.com/forms/d/e/1FAIpQLSc5hB2M-FHzs4gIK8WOnKRytX8r5bEAIhlMml1picl92-JbUw/viewform',
  integrateBidaliUrl:
    'https://webforms.pipedrive.com/f/2TySLLKtmatb9fI3hcug0l3ZqkmQIqsKVxnjVMaVq8oLwDIzoeBVi1lmL7TqCU2bx',
  walletConnectProjectId: '0d5734b282a1c247b4fcea074f029afb',
  walletConnectMetadata: {
    name: 'Bidali Giftcards',
    description: 'Buy giftcards with cryptocurrencies and stablecoins',
    url: 'https://giftcards.bidali.com',
    icons: ['https://assets.bidali.com/company/bidali/icon.png'],
  },
  xamanApiKey: valueOrNull(process.env.NEXT_PUBLIC_XAMAN_API_KEY),
  turnstileSiteKey: valueOrNull(process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY),
  termsUrl: 'https://www.bidali.com/legal/terms',
  privacyPolicyUrl: 'https://www.bidali.com/legal/privacy',
  minChromeVersion: process.env.NEXT_PUBLIC_MIN_CHROME_VERSION || 80,
};
